<label class="checkbox-container side-{{side}}" [class.disabled]="disabled">
  <ng-content></ng-content>
  <input type="checkbox" [id]="id" [name]="name" [checked]="isChecked" [disabled]="disabled"
         (change)="onCheckboxChange($event)">
  <span class="checkmark"><i class="fa fa-check"></i></span>
</label>